class Form {
    constructor() {
        this.animationSpeed = 0.08;
    }

    post(form, url, onSuccess, onError, resetForm) {
        if (typeof form === "string") {
            form = document.getElementById(form);
        }
        if (this.validate(form)) {
            this.blur(form);
            app.ajax.postForm(url ? url : window.location, new FormData(form), function (response) {
                if (response.status) {
                    if (typeof onSuccess == "function") {
                        onSuccess(response);
                    }
                    if (typeof response.callback == "string") {
                        setTimeout(function () {
                            eval(response.callback);
                        }, 1000);
                    }
                    app.form.addCheckMark(form);
                    app.form.clearFields(form);
                    if (resetForm) {
                        form.reset();
                    }
                } else {
                    app.form.errorResponse(form, response, onError);
                    if (typeof response.callback == "string") {
                        eval(response.callback);
                    }
                }
            }, function (response) {
                app.form.errorResponse(form, response, onError);
            });
        }
    }

    get(form, url, onSuccess, onError, resetForm) {
        if (typeof form === "string") {
            form = document.getElementById(form);
        }
        if (this.validate(form)) {
            this.blur(form);
            app.ajax.get(url ? url : window.location.pathname, this.getValuesAsJson(form), (response) => {
                if (response.status) {
                    if (typeof onSuccess == "function") {
                        onSuccess(response);
                    }
                    app.form.addCheckMark(form);
                    if (resetForm) {
                        form.reset();
                    }
                } else {
                    app.form.errorResponse(form, response, onError);
                    if (typeof response.callback == "string") {
                        eval(response.callback);
                    }
                }
            }, function (response) {
                app.form.errorResponse(form, response, onError);
            });
        }
    }

    getUrl(form) {
        return window.location.pathname + this.getValuesAsQuerystring(form);
    }

    errorResponse(form, response, onError) {
        this.clearFields(form);
        if (response.error) {
            if (response.title) {
                app.form.addErrorMessage(form, response.title, response.error);
            } else {
                app.form.addErrorMessage(form, "", response.error);
            }
        }
        for (let err in response.errors) {
            if (typeof form[err] === "object") {
                app.form.addFieldError(form[err], response.errors[err]);
            }
        }
        if (typeof onError == "function") {
            onError(response);
        }
    }

    addCheckMark(form) {
        app.util.addCheckMark(form);
    }

    blur(form) {
        let inputs = form.querySelectorAll("input");
        for (let input in inputs) {
            if (typeof inputs[input].blur == "function") {
                inputs[input].blur();
            }
        }
    }

    addErrorMessage(form, title, message) {
        let formErrorMessage = $(form).find("form-error-message");
        if (!formErrorMessage.length) {
            formErrorMessage = jQuery(document.createElement("form-error-message"));
            $(form).find("[type='submit']").before(formErrorMessage);
        }
        formErrorMessage.html("<h4>" + title + "</h4><p>" + message + "</p>");
        formErrorMessage.slideDown(app.form.animationSpeed * 1000);
    }

    addFieldError(field, error) {
        if (typeof field.parent == "undefined") {
            field.parent = jQuery(field).parents("div").first();
        }
        jQuery(field).removeClass("hidden").addClass("is-invalid");
        jQuery(field).parent().removeClass("hidden").addClass("is-invalid");
        if (typeof field.errorMess == "object") {
            field.errorMess.innerText = error;
        } else {
            field.errorMess = document.createElement("div");
            field.errorMess.classList.add("form-control-feedback");
            field.errorMess.innerText = error;
            $(field).after(field.errorMess);
        }
        if (error) {
            jQuery(field.errorMess).slideDown(200);
        }
    }

    validate(form) {
        let valid = true;
        for (var i = 0; i < form.elements.length; i++) {
            let validation = form.elements[i].getAttribute("data-validation");

            if (validation) {
                let validateIfNot = form.elements[i].getAttribute("data-validate-if-not");
                let validateChild = form.elements[i].getAttribute("data-validate-child");

                if (validateIfNot) {
                    validateIfNot = document.querySelector(validateIfNot);
                }
                if (validateChild) {
                    validateChild = document.querySelector(validateChild);
                }

                if (!app.validation.validate(validation, this.getValue(form.elements[i]), validateIfNot, validateChild)) {
                    let error = form.elements[i].getAttribute("data-validation-error");
                    app.form.addFieldError(form.elements[i], error);
                    valid = false;
                } else {
                    this.clearField(form.elements[i]);
                }
            }
        }

        return valid;
    }

    getValue(element) {
        switch (element.type) {
            case "checkbox":
                if (element.checked) {
                    return 1;
                } else {
                    return 0;
                }
                break;

            default:
                return element.value;
        }
    }

    getValuesAsJson(form) {
        let json = [];
        for (var i = 0; i < form.elements.length; i++) {
            if (form.elements[i].name) {
                json[form.elements[i].name] = this.getValue(form.elements[i])
            }
        }

        return json;
    }

    getValuesAsQuerystring(form) {
        let querystring = "";
        for (var i = 0; i < form.elements.length; i++) {
            if (form.elements[i].name) {
                querystring += "&" + form.elements[i].name + "=" + this.getValue(form.elements[i]);
            }
        }

        return "?" + querystring.substring(1);
    }


    clearField(field) {
        if (typeof field.errorMess == "object") {
            jQuery(field).removeClass("is-invalid");
            jQuery(field).parent().removeClass("is-invalid");
            jQuery(field.errorMess).slideUp(200);
        }
    }

    clearFields(form) {
        for (var i = 0; i < form.elements.length; i++) {
            this.clearField(form.elements[i]);
        }
        jQuery(form).find("form-error-message").slideUp(app.form.animationSpeed * 1000);
    }
}